import ui from '@nuxt/ui/vue-plugin'
import { setupAmplitude } from 'boot/amplitude'
import { installI18n } from 'boot/i18n'
import { installPinia } from 'boot/pinia'
import { setupSentry } from 'boot/sentry'
import { installSubdivision } from 'boot/subdivision'
import { mechtaIDAuthService } from 'src/adapters/auth/mechta-id.service'
import { createApp } from 'vue'
import App from './app/App.vue'
import yandexMetrika from './app/plugins/yandex-metrika'
import './app/css/app.css'

async function bootstrap() {
  const app = createApp(App)

  installPinia(app)
  await mechtaIDAuthService.initialize()

  // OIDC callback использует обычный путь /auth/callback, а приложение — hash routing.
  // Поэтому создаём router только после восстановления адреса в формате /#/...,
  // иначе Vue Router определит текущий маршрут как пустой.
  const { default: router } = await import('./app/router')

  installSubdivision(router)
  installI18n(app)
  setupSentry(app)
  setupAmplitude()
  app.use(yandexMetrika)
  app.use(router)
  app.use(ui)
  app.mount('#app')
}

void bootstrap()
